module.exports = __webpack_public_path__ + "static/media/file-code.89972a85.svg";